import request from '@/utils/request'

let Ma_resp_signingApi = {

  /*责任签署列表*/
  list(data) {
    return request._post('/shop/plus.ma_resp_signing.Index/index', data);
},
/*添加责任签署*/
add(data) {
    return request._post('/shop/plus.ma_resp_signing.Index/add', data);
},
/*修改责任签署*/
edit(data) {
    return request._post('/shop/plus.ma_resp_signing.Index/edit', data);
},
/*删除责任签署*/
del(data) {
    return request._post('/shop/plus.ma_resp_signing.Index/del', data);
},
/*责任签署详情*/
detail(data) {
  return request._post('/shop/plus.ma_resp_signing.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_resp_signing.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_resp_signing.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_resp_signing.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_resp_signing.Index/export', data);
    },
}
export default Ma_resp_signingApi;



// WEBPACK FOOTER //
// ./src/api/ma_resp_signing.js